"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.initialState = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.size = 4;
        this.board = this.initialState.map((row)=>row.slice());
        this.score = 0;
        this.status = "idle";
    }
    moveLeft() {
        let moved = false;
        if (this.status !== "playing") return;
        for(let i = 0; i < this.size; i++){
            let row = this.board[i].filter((item)=>item !== 0);
            for(let j = 0; j < row.length - 1; j++)if (row[j] === row[j + 1]) {
                row[j] *= 2;
                row[j + 1] = 0;
                this.score += row[j];
            }
            row = row.filter((item)=>item !== 0);
            while(row.length < this.size)row.push(0);
            if (this.board[i].join("") !== row.join("")) moved = true;
            this.board[i] = row;
        }
        if (moved) this.postMoved();
    }
    reverseRows() {
        this.board.forEach((row)=>row.reverse());
    }
    moveRight() {
        this.reverseRows();
        this.moveLeft();
        this.reverseRows();
    }
    transpose() {
        this.board = this.board[0].map((_, index)=>{
            return this.board.map((row)=>row[index]);
        });
    }
    moveUp() {
        this.transpose();
        this.moveLeft();
        this.transpose();
    }
    moveDown() {
        this.transpose();
        this.moveRight();
        this.transpose();
    }
    addRandom() {
        const emptyCells = [];
        for(let i = 0; i < this.size; i++){
            for(let j = 0; j < this.size; j++)if (this.board[i][j] === 0) emptyCells.push({
                x: i,
                y: j
            });
        }
        if (emptyCells.length === 0) return null;
        const { x: x, y: y } = emptyCells[Math.floor(Math.random() * emptyCells.length)];
        this.board[x][y] = Math.random() < 0.9 ? 2 : 4;
    }
    postMoved() {
        this.addRandom();
        if (this.checkWin()) this.status = "win";
        if (this.checkLose()) this.status = "lose";
    }
    checkWin() {
        return this.board.some((row)=>row.includes(2048));
    }
    checkLose() {
        for(let i = 0; i < this.size; i++)for(let j = 0; j < this.size; j++){
            if (this.board[i][j] === 0) return false;
            if (i > 0 && this.board[i][j] === this.board[i - 1][j]) return false;
            if (j > 0 && this.board[i][j] === this.board[i][j - 1]) return false;
            if (i < this.size - 1 && this.board[i][j] === this.board[i + 1][j]) return false;
            if (j < this.size - 1 && this.board[i][j] === this.board[i][j + 1]) return false;
        }
        return true;
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.board;
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.board = this.initialState.map((rows)=>rows.slice());
        this.status = "playing";
        this.score = 0;
        this.addRandom();
        this.addRandom();
    }
    restart() {
        this.board = this.initialState.map((rows)=>rows.slice());
        this.status = "idle";
        this.score = 0;
    }
}
// export default Game;
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


// // import Game from '../modules/Game.class';
const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$startGame = document.querySelector(".button.start");
const $09e991522ca7e64e$var$scoreElement = document.querySelector(".game-score");
const $09e991522ca7e64e$var$gameField = document.querySelector(".game-field");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
function $09e991522ca7e64e$var$updateBoard() {
    const board = $09e991522ca7e64e$var$game.getState();
    const rows = $09e991522ca7e64e$var$gameField.querySelectorAll(".field-row");
    board.forEach((row, i)=>{
        const cells = rows[i].querySelectorAll(".field-cell");
        row.forEach((value, j)=>{
            cells[j].textContent = value === 0 ? "" : value;
            cells[j].className = `field-cell field-cell--${value}`;
        });
        $09e991522ca7e64e$var$scoreElement.textContent = $09e991522ca7e64e$var$game.getScore();
    });
}
function $09e991522ca7e64e$var$updateMessage() {
    const statusGame = $09e991522ca7e64e$var$game.getStatus();
    $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    $09e991522ca7e64e$var$messageLose.classList.add("hidden");
    $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    if (statusGame === "idle") $09e991522ca7e64e$var$messageStart.classList.remove("hidden");
    if (statusGame === "win") $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
    if (statusGame === "lose") $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
    if (statusGame === "playing") {
        $09e991522ca7e64e$var$startGame.classList.remove("start");
        $09e991522ca7e64e$var$startGame.classList.add("restart");
        $09e991522ca7e64e$var$startGame.textContent = "Restart";
    }
}
document.addEventListener("keydown", $09e991522ca7e64e$var$handlePressKey);
function $09e991522ca7e64e$var$handlePressKey(pressKey) {
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    switch(pressKey.key){
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            return;
    }
    $09e991522ca7e64e$var$updateBoard();
    $09e991522ca7e64e$var$updateMessage();
}
$09e991522ca7e64e$var$startGame.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$game.start();
    $09e991522ca7e64e$var$updateBoard();
    $09e991522ca7e64e$var$updateMessage();
});
$09e991522ca7e64e$var$updateBoard();
$09e991522ca7e64e$var$updateMessage();


//# sourceMappingURL=index.1f694be1.js.map
